import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { LoanComputedResult } from 'src/app/_shared/interface/loan-computation.interface';
import { MyHomeState } from '../../state/my-home.state';
@Component({
  selector: 'app-refinance',
  templateUrl: './refinance.component.html',
  styleUrls: ['./refinance.component.scss'],
})
export class RefinanceComponent implements OnInit, OnDestroy, OnChanges {
  constructor(private myHomeState: MyHomeState, private cdr: ChangeDetectorRef) {}

  @Input() mortgageList;
  mortgageArray = [];
  activeTabIndex = 0;
  totalMortgageList = [];
  selectedMortgageList = [];
  consolidatedMortgage = {
    principal: 0,
    interest: 0,
    term: 0,
    startDate: null,
  };
  mortgage;

  computedLoan;
  closeByYears = 0;
  closeByMonths = 0;
  loanInterest = 0;
  term1 = 15;
  term1InterestRate = 0;
  term1MonthlyPayment = 0;
  term1ChangeInPayment = 0;
  term1TotalSavings = 0;
  term2 = 20;
  term2InterestRate = 0;
  term2MonthlyPayment = 0;
  term2ChangeInPayment = 0;
  term2TotalSavings = 0;
  term3 = 30;
  term3InterestRate = 0;
  term3MonthlyPayment = 0;
  term3ChangeInPayment = 0;
  term3TotalSavings = 0;
  term1ComputedLoan: LoanComputedResult;
  term2ComputedLoan: LoanComputedResult;
  term3ComputedLoan: LoanComputedResult;
  errorMessage = 'Invalid';
  stackedPercentBarChartConfig = {};
  barChartConfig;
  errorInField: any = {};
  isChartVisible = false;
  refinanceForm = new FormGroup({});
  activeRefinance: number = 1;
  onDestroyNotifier$ = new Subject();
  ngOnInit() {
    this.mortgage = this.mortgageArray[0];
  }

  ngOnChanges() {
    this.mortgageArray = this.mortgageList;
  }

  activeMortgageValue(mortgageValue) {}
  tabChange(event) {
    this.activeTabIndex = event.index;
    this.myHomeState.selectedMortgageIndexValue = event.index;
    this.mortgage = this.mortgageArray[event.index];
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
